/**
 * Error Message Mappings
 * Maps error codes to user-friendly messages for i18n
 */

import { DatabaseErrorCode, ErrorCode } from './error-codes.js'

// Error message mapping type
export interface ErrorMessage {
  code: ErrorCode
  defaultMessage: string
  userMessage: string
  severity: 'error' | 'warning' | 'info'
  category: 'auth' | 'validation' | 'system' | 'business' | 'ui'
}

// Error messages registry (database errors only — other categories removed)
export const ERROR_MESSAGES: Record<ErrorCode, ErrorMessage> = {
  [DatabaseErrorCode.RECORD_NOT_FOUND]: {
    code: DatabaseErrorCode.RECORD_NOT_FOUND,
    defaultMessage: 'Record not found',
    userMessage: 'Registro no encontrado',
    severity: 'error',
    category: 'system',
  },
  [DatabaseErrorCode.DUPLICATE_RECORD]: {
    code: DatabaseErrorCode.DUPLICATE_RECORD,
    defaultMessage: 'Duplicate record',
    userMessage: 'Registro duplicado',
    severity: 'error',
    category: 'system',
  },
  [DatabaseErrorCode.FOREIGN_KEY_CONSTRAINT]: {
    code: DatabaseErrorCode.FOREIGN_KEY_CONSTRAINT,
    defaultMessage: 'Foreign key constraint violation',
    userMessage: 'Error de integridad de datos',
    severity: 'error',
    category: 'system',
  },
  [DatabaseErrorCode.DATABASE_ERROR]: {
    code: DatabaseErrorCode.DATABASE_ERROR,
    defaultMessage: 'Database error',
    userMessage: 'Error de base de datos',
    severity: 'error',
    category: 'system',
  },
  [DatabaseErrorCode.TRANSACTION_FAILED]: {
    code: DatabaseErrorCode.TRANSACTION_FAILED,
    defaultMessage: 'Transaction failed',
    userMessage: 'Operación fallida',
    severity: 'error',
    category: 'system',
  },
}

// Helper function
export const getErrorMessage = (code: ErrorCode): ErrorMessage => {
  return ERROR_MESSAGES[code]
}
